<template>
    <div class="page-layout blank contacts-manage ml-3">
        <div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallInProgress">
            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
        </div>
        <div class="pb-5 pr-2" v-else-if="!ajaxCallInProgress">
            <div class="breadcrumbnew">
                <span>Call Report</span>
                <span @click="$router.push('/callreportlist')">List View</span>
                <span @click="$router.push('/callreport')">Create New</span>
                <a>{{ createJson.call_report_category }}</a>
            </div>
            <div class="block-callreport pt-4">
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/digiLogo.svg" alt=""
                            style="width:200px;">
                    </div>
                    <div class="d-flex">
                        <button v-if="sent && userPermissions.call_reports.permitted_actions.send" class="btn btn-des btn-new-primary pl-2 btn-smm ml-2"
                            @click="forwardCallReport">
                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/Forward.svg"
                                height="12px">
                            <span class="text-white ml-1 hidden-sm-down fs-13">Forward</span>
                        </button>
                        <button v-if="sent && userPermissions.call_reports.permitted_actions.clone" class="btn btn-des btn-new-green pl-2 btn-smm ml-2" @click="copyCallReport">
                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/copy-white.svg"
                                height="12px">
                            <span class="text-white ml-1 hidden-sm-down fs-13">Clone</span>
                        </button>
                        <button v-if="sent" class="btn btn-des btn-new-primary pl-2 btn-smm ml-2">
                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/printer.svg">
                            <span class="text-white ml-1 hidden-sm-down fs-13">Print</span>
                        </button>
                        <button v-if="sent" class="btn btn-des btn-new-danger pl-2 btn-smm ml-2">
                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/pdf-new.svg"
                                height="18px">
                            <span class="text-white ml-1 hidden-sm-down fs-13">Pdf</span>
                        </button>
                    </div>
                </div>
                <div class="report-barcode d-flex justify-content-between align-items-center mt-10 mb-8">
                    <div v-if="sent">
                        <div class="fs-18 fw-600 text-secondary">Call Report Number:</div>
                        <div class="fs-18 fw-600 text-dark">{{ createJson.call_report_number }}</div>
                    </div>
                    <div>
                        <div class="report-title text-uppercase">CALL REPORT - {{ createJson.call_report_category }}
                        </div>
                    </div>
                    <div v-if="sent">
                        <div>
                            <img src="https://cdn.digicollect.com/cdn/scmnew/images/scm/qr.svg" alt=""
                                style="width:80px">
                        </div>
                    </div>
                </div>
                <div class="basic-info">
                    <div class="infoHeaderHideShow mt-3 mb-3">
                        <div class="descriptionheader">
                            <div class="description-text-header-left">
                                <h5 class="font-weight-bold whiteSpace">Basic Information</h5>
                            </div>
                            <div class="description-text-header-right">
                                <span class="collapse-addon">
                                    <i v-if="!sent" @click="edit('callreporttab')"
                                        class="icon-pencil text-white fs-18"></i>
                                    <i v-if="showBasicInfo" @click="expandBasicInfo"
                                        class="icon-chevron-double-up text-white fs-20 ml-4"></i>
                                    <i v-else @click="expandBasicInfo"
                                        class="icon-chevron-double-down text-white fs-20  ml-4"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="showBasicInfo">
                        <div class="col-lg-4 col-md-4 col-sm-12 ">
                            <div>
                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                    Report Title
                                    <!-- <sup class="fs-14 ml-02 mandatory">*</sup> -->
                                </span>
                            </div>
                            <div class="review-borders">
                                <span>{{createJson.title || "-"}}</span>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 ">
                            <div>
                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                    Author Name
                                </span>
                            </div>
                            <div class="review-borders">
                                <span>{{createJson.author_name || "-"}}</span>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 ">
                            <div>
                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                    Author Email
                                </span>
                            </div>
                            <div class="review-borders">
                                <span>{{createJson.author_email || "-"}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-4" v-if="showBasicInfo">
                        <div class="col-lg-4 col-md-4 col-sm-12 ">
                            <div>
                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                    Report Owner
                                </span>
                            </div>
                            <div class="review-borders">
                                <span>{{createJson.owner_name ? createJson.owner_name : "-"}}</span>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 ">
                            <div>
                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                    Owner Email
                                </span>
                            </div>
                            <div class="review-borders">
                                <span>{{createJson.owner_email || "-"}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="company-info mt-10">
                    <div class="infoHeaderHideShow mt-3 mb-3">
                        <div class="descriptionheader">
                            <div class="description-text-header-left">
                                <h5 class="font-weight-bold whiteSpace">Company Details</h5>
                            </div>
                            <div class="description-text-header-right">
                                <span class="collapse-addon">
                                    <i v-if="!sent" @click="edit('callreporttab')"
                                        class="icon-pencil text-white fs-18"></i>
                                    <i v-if="showCompanyDetails" @click="expandCompanyDetails"
                                        class="icon-chevron-double-up text-white ml-4"></i>
                                    <i v-else @click="expandCompanyDetails"
                                        class="icon-chevron-double-down text-white ml-4"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div v-if="showCompanyDetails">
                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-6">
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div>
                                            <span class="ml-2 fs-14 fw-600 text-secondary">
                                                Company Name
                                            </span>
                                        </div>
                                        <div class="review-borders">
                                            <span>{{createJson.internal_company.name || "-"}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-5">
                                    <div class="col-lg-12 col-md-12 col-sm-12 mt-5">
                                        <div>
                                            <span class="ml-2 fs-14 fw-600 text-secondary">
                                                Other Company Attendee
                                            </span>
                                        </div>
                                        <div class="review-borders" style="min-height:112px">
                                            <div class="secondary-email-list height-align">
                                                <template v-if="createJson.internal_company.other_email.length">
                                                    <span class="secondary-email"
                                                        v-for="(employee,index) in createJson.internal_company.other_email"
                                                        :key="index">{{employee || "-"}}</span>
                                                </template>
                                                <template v-else>
                                                    <span class="secondary-email">{{"-"}}</span>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="row mt-4">
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div>
                                            <span class="ml-2 fs-14 fw-600 text-secondary">
                                                Branch Name
                                            </span>
                                        </div>
                                        <div class="review-borders">
                                            <span v-if="is_create_edit == 'edit'">{{createJson.internal_company.branch.name || "-"}}</span>
                                            <span v-if="is_create_edit == 'create'" >{{createJson.internal_company.branch.name || "-"}}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div>
                                            <span class="ml-2 fs-14 fw-600 text-secondary">
                                                Department Name
                                            </span>
                                        </div>
                                        <div class="review-borders">
                                            <span>{{createJson.internal_company.department || "-"}}</span>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                            <div class="col-lg-8 col-md-8 col-sm-6">
                                <div>
                                    <span class="ml-2 fs-14 fw-600 text-secondary">
                                        Company Attendees
                                    </span>
                                </div>
                                <div class="review-borders" style="min-height:112px">
                                    <div class="secondary-email-list height-align">
                                        <template v-if="createJson.internal_company.company_attendees.length">
                                            <span class="secondary-email"
                                                v-for="(employee,index) in createJson.internal_company.company_attendees"
                                                :key="index">{{employee || "-"}}</span>
                                        </template>
                                        <template v-else>
                                            <span class="secondary-email">{{"-"}}</span>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-lg-4 col-md-4 col-sm-6" v-if="is_enable">
                                <div>
                                    <span class="ml-2 fs-14 fw-600 text-secondary">
                                        Subsidiary Company Attendees
                                    </span>
                                </div>
                                <div class="review-borders" style="min-height:112px">
                                    <div class="secondary-email-list height-align">
                                         <span class="text-center" v-if="createJson.internal_company.subsidiary_attendees.length == 0">
                                            -
                                         </span>
                                        <span class="secondary-email" v-else
                                            v-for="(employee,index) in createJson.internal_company.subsidiary_attendees"
                                            :key="index">{{employee.full_name}}</span>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div v-if="createJson.call_report_category == 'External Meeting' || createJson.call_report_category == 'Sales Meeting' || createJson.call_report_category == 'Release Notes'">
                    <div class="mt-5 mb-1">
                        <div class="infoHeaderHideShow mt-3 mb-3">
                            <div class="descriptionheader mt-3">
                                <div class="description-text-header-left">
                                    <h5 class="fw-500 whiteSpace">Receiver Type</h5>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12">
                                <div class="d-flex align-items-center my-3">
                                    <span class="text-secondary whiteSpace fs-14 fw-600 mr-3">Receiver type :</span>
                                    <div
                                        class="d-flex justify-content-between mr-2 align-items-center">
                                        <div
                                            class="form-check form-check-inline mb-1 ">
                                            <label class="form-check-label check-label-dc">
                                                <input class="form-check-input"
                                                    type="radio"
                                                    value="lead"
                                                    name="receiver_lead" disabled
                                                    v-model="createJson.receiver_type" />
                                                <span class="radio-icon"></span>
                                            </label>
                                        </div>
                                        <span
                                            class="text-secondary fs-14 fw-600 mr-7">Lead</span>
                                    </div>
                                    <div
                                        class="d-flex justify-content-between align-items-center">
                                        <div
                                            class="form-check form-check-inline mr-2 mb-1">
                                            <label
                                                class="form-check-label check-label-dc">
                                                <input class="form-check-input"
                                                    type="radio"
                                                    value="contact" disabled
                                                    name="receiver_contact"

                                                    v-model="createJson.receiver_type" />
                                                <span class="radio-icon"></span>
                                            </label>
                                        </div>
                                        <span
                                            class="text-secondary fs-14 fw-600 mr-7">Contact</span>
                                    </div>
                                    <div
                                        class="d-flex justify-content-between align-items-center">
                                        <div
                                            class="form-check form-check-inline mr-2 mb-1  ">
                                            <label
                                                class="form-check-label check-label-dc">
                                                <input class="form-check-input"
                                                    type="radio" disabled
                                                    value="customer"
                                                    name="receiver_customer"

                                                    v-model="createJson.receiver_type" />
                                                <span class="radio-icon"></span>
                                            </label>
                                        </div>
                                        <span
                                            class="text-secondary fs-14 fw-600 mr-7">Customer</span>
                                    </div>
                                    <div
                                        class="d-flex justify-content-between align-items-center">
                                        <div
                                            class="form-check form-check-inline mr-2 mb-1">
                                            <label
                                                class="form-check-label check-label-dc">
                                                <input class="form-check-input"
                                                    type="radio"
                                                    value="vendor" disabled
                                                    name="receiver_vendor"

                                                    v-model="createJson.receiver_type" />
                                                <span class="radio-icon"></span>
                                            </label>
                                        </div>
                                        <span
                                            class="text-secondary fs-14 fw-600 mr-7">Vendor</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="createJson.receiver_type == 'lead'">
                        <div class="mt-3" v-for="(lead, index) in createJson.lead_info" :key="index">
                            <div class="infoHeaderHideShow mt-3 mb-3">
                                <div class="descriptionheader mt-3">
                                    <div class="description-text-header-left">
                                        <h5 class="fw-500 whiteSpace">Receiver Details - {{index+1}}</h5>
                                    </div>
                                    <div class="description-text-header-right">
                                        <span class="collapse-addon" @click="expandLeadDetails(index)">
                                            <i v-if="!sent" @click="edit('callreporttab')" class="icon-pencil text-white fs-18"></i>
                                            <i v-if="showReceiverDetails.includes(index)"
                                                class="icon-chevron-double-up text-white ml-4"></i>
                                            <i v-else 
                                                class="icon-chevron-double-down text-white ml-4"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="showReceiverDetails.includes(index)">
                                <div class="col-lg-12 col-md-12 col-sm-12 pb-3" v-if="createJson.receiver_type == 'lead'">
                                    <div class="row">
                                        <div class="col-lg-4 col-md-4 col-sm-12 " >
                                            <span class="ml-2 fs-14 fw-600 text-secondary">Lead Name </span>
                                            <div class="review-borders">
                                                <span>
                                                    {{lead.name || '-'}}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12" >
                                            <span class="ml-2 fs-14 fw-600 text-secondary">Company Name </span>
                                            <div class="review-borders"  >
                                                <span >
                                                    {{lead.company_name || '-'}}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12" >
                                            <span class="ml-2 fs-14 fw-600 text-secondary">Lead Status </span>
                                            <div class="review-borders" >
                                               <span >
                                                    {{lead.status || '-'}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div v-if="createJson.receiver_type == 'contact'">
                        <div class="mt-3" v-for="(contact, index) in createJson.contact_info" :key="index">
                            <div class="infoHeaderHideShow mt-3 mb-3">
                                <div class="descriptionheader mt-3">
                                    <div class="description-text-header-left">
                                        <h5 class="fw-500 whiteSpace">Receiver Details</h5>
                                    </div>
                                    <div class="description-text-header-right" >
                                        <span class="collapse-addon" @click="expandContactDetails(index)">
                                            <i v-if="!sent" @click="edit('callreporttab')" class="icon-pencil text-white fs-18"></i>
                                            <i v-if="showContactDetails.includes(index)"
                                                class="icon-chevron-double-up text-white ml-4"></i>
                                            <i v-else 
                                                class="icon-chevron-double-down text-white ml-4"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="showContactDetails.includes(index)">
                                <div  class="col-lg-12 col-md-12 col-sm-12 pb-3">
                                    <div class="row">
                                        <div class="col-lg-4 col-md-4 col-sm-12" >
                                        <span class="ml-2 fs-14 fw-600 text-secondary">Contact Name </span>
                                            <div>

                                                <div class=" align-items-center">
                                                    <div class="review-borders mt-1">
                                                    <span >
                                                            {{contact.name || '-'}}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div  class="col-lg-4 col-md-4 col-sm-12">
                                            <span class="ml-2 fs-14 fw-600 text-secondary">CompanyName </span>
                                            <div
                                                class="d-flex align-items-center">
                                                <div class="w-100 review-borders">
                                                <span>
                                                        {{contact.company_name || '-'}}
                                                    </span>
                                                </div>
                                                <span class="mt-3">
                                                    <i
                                                        class="icon icon-check-circle fs-30 ml-2 text-green"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="createJson.receiver_type == 'customer'">
                        <div class="customer-info mt-3" v-for="(company,index) in createJson.external_attendees" :key="index">
                            <div class="infoHeaderHideShow mt-3 mb-3">
                                <div class="descriptionheader mt-3">
                                    <div class="description-text-header-left">
                                        <h5 class="font-weight-bold whiteSpace">Receiver Details - {{index + 1}}</h5>
                                    </div>
                                    <div class="description-text-header-right">
                                        <span class="collapse-addon" @click="expandCustomerDetails(index)">
                                            <i v-if="!sent" @click="edit('callreporttab')"
                                                class="icon-pencil text-white fs-18"></i>
                                            <i v-if="showCustomerDetails.includes(index)"
                                                class="icon-chevron-double-up text-white"></i>
                                            <i v-else
                                                class="icon-chevron-double-down text-white"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="showCustomerDetails.includes(index)">
                                <div class="col-lg-8 col-md-8 col-sm-12">
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 col-sm-12">
                                            <div>
                                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                                    Customer Company Name
                                                </span>
                                            </div>
                                            <div class="review-borders">
                                                <span>{{company.name || "-"}}</span>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-12">
                                            <div>
                                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                                    Primary Customer Attendee
                                                </span>
                                            </div>
                                            <div class="review-borders">
                                                <span>{{company.primary_email || "-"}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-4">
                                        <div class="col-lg-6 col-md-6 col-sm-12">
                                            <div>
                                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                                    Branch Name
                                                </span>
                                            </div>
                                            <div class="review-borders">
                                                <span>{{company.branch || "-"}}</span>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-12">
                                            <div>
                                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                                    Department Name
                                                </span>
                                            </div>
                                            <div class="review-borders">
                                                <span>{{company.department || "-"}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-4">
                                        <div class="col-lg-6 col-md-6 col-sm-12">
                                            <div>
                                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                                    Customer status
                                                    <!-- <sup class="fs-14 ml-02 mandatory">*</sup> -->
                                                </span>
                                            </div>
                                            <div class="review-borders">
                                                <span>{{company.status || "-"}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-12">
                                    <div>
                                        <span class="ml-2 fs-14 fw-600 text-secondary">
                                            Secondary Customer Attendee
                                        </span>
                                    </div>
                                    <div class="review-borders" style="min-height:112px">
                                        <div class="secondary-email-list height-align">
                                            <span class="secondary-email"
                                                v-for="(employee,index) in company.secondary_email"
                                                :key="index">
                                                <span v-if="employee.primary_email">
                                                    {{employee.primary_email || "-"}}
                                                </span>
                                                <span v-else>
                                                    {{employee || "-"}}
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="createJson.receiver_type == 'vendor'">
                        <div class="mt-3" v-for="(vendor, index) in createJson.vendor_info" :key="index">
                            <div class="infoHeaderHideShow mt-3 mb-3">
                                <div class="descriptionheader mt-3">
                                    <div class="description-text-header-left">
                                        <h5 class="fw-500 whiteSpace">Receiver Details - {{index+1}}</h5>
                                    </div>
                                    <div class="description-text-header-right">
                                        <span class="collapse-addon" @click="expandVendorDetails(index)">
                                            <i v-if="!sent" @click="edit('callreporttab')" class="icon-pencil text-white fs-18"></i>
                                            <i v-if="showVendorDetails.includes(index)"
                                                class="icon-chevron-double-up text-white ml-4"></i>
                                            <i v-else
                                                class="icon-chevron-double-down text-white ml-4"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="showVendorDetails.includes(index)">
                                <div class="col-lg-12 col-md-12 col-sm-12 pb-3" v-if="createJson.receiver_type == 'vendor'">
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 col-sm-12 " >
                                            <span class="ml-2 fs-14 fw-600 text-secondary">Vendor Name </span>
                                            <div class="review-borders">
                                                <span>
                                                    {{vendor.name || '-'}}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-12" >
                                            <span class="ml-2 fs-14 fw-600 text-secondary">Vendor Email ID</span>
                                            <div class="review-borders"  >
                                                <span >
                                                    {{vendor.vendor_primary_attendee || '-'}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="recipients-info mt-10">
                    <div class="infoHeaderHideShow mt-3 mb-3">
                        <div class="descriptionheader">
                            <div class="description-text-header-left">
                                <h5 class="font-weight-bold whiteSpace">Email Shared</h5>
                            </div>
                            <div class="description-text-header-right">
                                <span class="collapse-addon">
                                    <i v-if="!sent" @click="edit('callreporttab')"
                                        class="icon-pencil text-white fs-18"></i>
                                    <i v-if="showEmailRecipients" @click="expandEmailRecipients"
                                        class="icon-chevron-double-up text-white ml-4"></i>
                                    <i v-else @click="expandEmailRecipients"
                                        class="icon-chevron-double-down text-white ml-4"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="showEmailRecipients">
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <span class="text-secondary fs-14 fw-600 mr-7">Individual</span>
                            <div class="review-borders" style="min-height:80px">
                                <div v-if="createJson.recipient_email.individual != ''">
                                    <div class="secondary-email-list">
                                        <span class="secondary-email" v-for="(email,index) in createJson.recipient_email.individual"
                                            :key="index">{{typeof email === 'object' ? email.email : email }}</span>
                                    </div>
                                </div>
                                <div v-else class="secondary-email-list">
                                    <span class="">-</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <span class="text-secondary fs-14 fw-600 mr-7">Team</span>
                            <div class="review-borders" style="min-height:80px">
                                <div v-if="createJson.recipient_email.team != ''">
                                    <div class="secondary-email-list">
                                        <span class="secondary-email" v-for="(email,index) in createJson.recipient_email.team"
                                            :key="index">{{typeof email === 'object' ? email.email_id : email }}</span>
                                    </div>
                                </div>
                                <div v-else class="secondary-email-list">
                                    <span class="">-</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="recipients-info mt-10">
                    <div class="infoHeaderHideShow mt-3 mb-3">
                        <div class="descriptionheader">
                            <div class="description-text-header-left">
                                <h5 class="font-weight-bold whiteSpace">Call Report Permissions</h5>
                            </div>
                            <div class="description-text-header-right">
                                <span class="collapse-addon">
                                    <i v-if="!sent" @click="edit('callreporttab')"
                                        class="icon-pencil text-white fs-18"></i>
                                    <i v-if="showPermissions" @click="expandPermission"
                                        class="icon-chevron-double-up text-white ml-4"></i>
                                    <i v-else @click="expandPermission"
                                        class="icon-chevron-double-down text-white ml-4"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="showPermissions">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="">
                                <div class="row my-3">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div  v-if="createJson.author_email">
                                            <span class="text-secondary whiteSpace fs-14 fw-600">Author :</span>
                                            <span class="chipmailCallReport" >
                                                {{createJson.author_email || "-"}}
                                            </span>
                                        </div>
                                        <div class="mt-3" v-if="createJson.owner_email">
                                            <span class="text-secondary whiteSpace fs-14 fw-600">Owner :</span>
                                            <span class="chipmailCallReport">
                                                {{createJson.owner_email || "-"}}
                                            </span>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <span class="text-secondary fs-14 fw-600 mr-7">Individual</span>
                            <div class="review-borders" style="min-height:80px">
                                <div v-if="createJson.permissions.individual != ''">
                                    <div class="secondary-email-list">
                                        <span class="secondary-email" v-for="(email,index) in createJson.permissions.individual"
                                            :key="index">{{typeof email === 'object' ? email.email_id : email }} </span>
                                    </div>
                                </div>
                                <div v-else class="secondary-email-list">
                                    <span class="">-</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <span class="text-secondary fs-14 fw-600 mr-7">Team</span>
                            <div class="review-borders" style="min-height:80px">
                                <div v-if="createJson.permissions.team != ''">
                                    <div class="secondary-email-list">
                                        <span class="secondary-email" v-for="(email,index) in createJson.permissions.team"
                                            :key="index">{{typeof email === 'object' ? email.email_id : email }}</span>
                                    </div>
                                </div>
                                <div v-else class="secondary-email-list">
                                    <span class="">-</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="permissions-info mt-10">
                    <div class="infoHeaderHideShow mt-3 mb-3" >
                        <div class="descriptionheader">
                            <div class="description-text-header-left">
                                <h5 class="font-weight-bold whiteSpace">Permissions</h5>
                            </div>
                            <div class="description-text-header-right">
                                <span class="collapse-addon">
                                  <i v-if="!sent" @click="edit" class="icon-pencil text-white fs-14"></i>
                                  <i v-else class="icon-chevron-double-up text-white"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div>
                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                    Team
                                </span>
                            </div>
                            <div class="review-borders" style="min-height:80px">
                                <div class="secondary-email-list">
                                    <span class="secondary-email">{{createJson.teams}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div>
                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                    Individual
                                </span>
                            </div>
                            <div class="review-borders" style="min-height:80px">
                                <div class="secondary-email-list">
                                    <span class="secondary-email">{{createJson.individual}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="meeting-info mt-10">
                    <div class="infoHeaderHideShow mt-3 mb-3">
                        <div class="descriptionheader">
                            <div class="description-text-header-left">
                                <h5 class="font-weight-bold whiteSpace">Meeting Information</h5>
                            </div>
                            <div class="description-text-header-right">
                                <span class="collapse-addon">
                                    <i v-if="!sent" @click="edit('callreporttab')"
                                        class="icon-pencil text-white fs-18"></i>
                                    <i v-if="showMeetingInformation" @click="expandMeetingInformation"
                                        class="icon-chevron-double-up text-white ml-4"></i>
                                    <i v-else @click="expandMeetingInformation"
                                        class="icon-chevron-double-down text-white ml-4"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="showMeetingInformation">
                        <div class="col-lg-4 col-md-4 col-sm-12">
                            <div>
                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                    Call Report Type
                                </span>
                            </div>
                            <div class="review-borders">
                                <span>{{createJson.call_report_type || "-"}}</span>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12">
                            <div>
                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                    Meeting Type
                                </span>
                            </div>
                            <div class="review-borders">
                                <span>{{createJson.meeting_type || "-"}}</span>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12">
                            <div>
                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                    Branch Name
                                </span>
                            </div>
                            <div class="review-borders">
                                <!-- <span v-if="is_create_edit == 'edit'">{{createJson.branch_name || "-"}}</span> -->
                                <!-- <span v-if="is_create_edit == 'create'" >{{createJson.branch_name || "-"}}</span> -->
                                <span>{{createJson.branch_name || "-"}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-5" v-if="showMeetingInformation">
                        <div class="col-lg-4 col-md-4 col-sm-12 d-flex">
                            <div style="width:70%;margin-right:15px">
                                <div>
                                    <span class="ml-2 fs-14 fw-600 text-secondary">
                                        Start Date
                                        <!-- <sup class="fs-14 ml-02 mandatory">*</sup> -->
                                    </span>
                                </div>
                                <div class="review-borders">
                                    <span>{{createJson.start_date || "-"}}</span>
                                </div>
                            </div>
                            <div style="width:30%">
                                <div>
                                    <span class="ml-2 fs-14 fw-600 text-secondary">
                                        Start Time
                                        <!-- <sup class="fs-14 ml-02 mandatory">*</sup> -->
                                    </span>
                                </div>
                                <div class="review-borders">
                                    <span>
                                        {{createJson.start_time || ''}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 d-flex">
                            <div style="width:70%;margin-right:15px">
                                <div>
                                    <span class="ml-2 fs-14 fw-600 text-secondary">
                                        End Date
                                        <!-- <sup class="fs-14 ml-02 mandatory">*</sup> -->
                                    </span>
                                </div>
                                <div class="review-borders">
                                    <span>{{createJson.end_date || "-"}}</span>
                                </div>
                            </div>
                            <div style="width:30%">
                                <div>
                                    <span class="ml-2 fs-14 fw-600 text-secondary">
                                        End Time
                                        <!-- <sup class="fs-14 ml-02 mandatory">*</sup> -->
                                    </span>
                                </div>
                                <div class="review-borders">
                                    <span>
                                        {{createJson.end_time || "-"}}
                                    </span>
                                    <!-- <span v-if="createJson.meeting_time_to && createJson.meeting_time_to.includes('T')">{{ createJson.meeting_time_to.split("T")[1].split(".")[0] }}</span>
                                    <span v-else-if="createJson.meeting_time_to && createJson.meeting_time_to.includes(' ')">{{ createJson.meeting_time_to.split(" ")[1].split(".")[0] }}</span>
                                    <span v-else>-</span> -->
                                    <!-- <span>{{createJson.meeting_time_to.split("T")[1].split(":")[0]+":"+createJson.meeting_time_to.split("T")[1].split(":")[1] }}</span> -->
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12">
                            <div>
                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                    Meeting Location
                                </span>
                            </div>
                            <div class="d-flex w-100">
                                <div class="review-borders w-100 mr-3">
                                    <span>{{meeting_location_vmodel}}</span>
                                </div>
                                <div>
                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/gpsicon.svg"
                                        alt="" style="height:34px;margin-top:7px">
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row mt-5" v-if="showMeetingInformation">
                        <div class="col-lg-4 col-md-4 col-sm-12">
                            <div>
                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                    Country
                                </span>
                            </div>
                            <div class="review-borders">
                                <span>{{createJson.meeting_location.country || "-"}}</span>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12">
                            <div>
                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                    State
                                </span>
                            </div>
                            <div class="review-borders">
                                <span>{{createJson.meeting_location.state || "-"}}</span>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12">
                            <div>
                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                    City
                                </span>
                            </div>
                            <div class="review-borders">
                                <span>{{createJson.meeting_location.city || "-"}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-5" v-if="showMeetingInformation">
                        <div class="col-lg-4 col-md-4 col-sm-12">
                            <div>
                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                    Township
                                </span>
                            </div>
                            <div class="review-borders">
                                <span>{{createJson.meeting_location.township || "-"}}</span>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12">
                            <div>
                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                    Street
                                </span>
                            </div>
                            <div class="review-borders">
                                <span>{{createJson.meeting_location.street || "-"}}</span>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12">
                            <div>
                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                    ZipCode
                                </span>
                            </div>
                            <div class="review-borders">
                                <span>{{createJson.meeting_location.zip_code || "-"}}</span>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div class="meeting-notes-info mt-10">
                    <div class="infoHeaderHideShow mt-3 mb-3">
                        <div class="descriptionheader">
                            <div class="description-text-header-left">
                                <!-- <h5 class="font-weight-bold whiteSpace">Meeting Notes</h5> -->
                                <h5 class="font-weight-bold whiteSpace">{{ createJson.call_report_category == 'Release Notes' ? 'Release Notes' : 'Meeting Notes' }}</h5>
                            </div>
                            <div class="description-text-header-right">
                                <span class="collapse-addon">
                                    <i v-if="!sent" @click="edit('meetingnotestab')"
                                        class="icon-pencil text-white fs-18"></i>
                                    <i v-if="showMeetingNotes" @click="expandMeetingNotes"
                                        class="icon-chevron-double-up text-white ml-4"></i>
                                    <i v-else @click="expandMeetingNotes"
                                        class="icon-chevron-double-down text-white ml-4"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="pl-3 fw-500 fs-14 text-dark" v-if="showMeetingNotes">
                        <span>Report Title :</span><span style="word-break: break-word">
                            {{createJson.meeting_notes_subject}}</span>
                    </div>
                    <div class="pl-3 mt-3" v-if="showMeetingNotes && createJson.meeting_notes!= ''" style="white-space: pre-wrap;word-wrap: break-word;">
                        <!-- <span v-html="createJson.meeting_notes"></span> -->
                        <div class="example">
                            <!-- <span class="fw-500 fs-14 text-dark" >Add Meeting Notes:</span> -->
                            <span class="fw-500 fs-14 text-dark" >{{ createJson.call_report_category == 'Release Notes' ? 'Release Notes' : 'Meeting Notes' }} Added:</span>
                            <div class="output ql-snow fs-14">
                                <div class="ql-editor fw-500 fs-14" v-html="createJson.meeting_notes"></div>
                            </div>
                        </div>
                    </div>
                    <div v-if="showMeetingNotes">
                        <div class="mt-10" v-for="(table,index) in createJson.meeting_notes_table" :key="index">
                            <div>
                                <span class="fw-600 text-secondary fs-14">Table Name:</span>
                                <span class="ml-3 text-dark fs-14 fw-400">{{table.meeting_notes_table_name}}</span>
                            </div>
                            <div class="table-responsive mt-10 w-100" style="overflow-x:auto;">
                                <table class="meeting-notes-table w-100">
                                    <tbody>
                                        <tr v-for="(data,index) in table.meeting_notes_table_data" :key="index">
                                            <td v-for="(data,index) in data" :key="index" style="height: 38px">{{data}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div v-if="attachments.length" class="attachments-info mt-10">
                        <div class="infoHeaderHideShow mt-3 mb-3">
                            <div class="descriptionheader">
                                <div class="description-text-header-left">
                                    <h5 class="font-weight-bold whiteSpace">Attachments</h5>
                                </div>
                                <div class="description-text-header-right">
                                    <span class="collapse-addon">
                                        <i v-if="!sent" @click="edit('meetingnotestab')"
                                            class="icon-pencil text-white fs-14"></i>
                                        <i v-if="showMeetingNotes" @click="expandAttachments"
                                            class="icon-chevron-double-up text-white"></i>
                                        <i v-else @click="expandAttachments"
                                            class="icon-chevron-double-down text-white"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="files.length && showAttachments" class="files-attachments">
                        <div class="title_files">
                            <div class="d-flex justify-content-between w-50">
                                <span class="file-text">FILES</span>
                            </div>
                        </div>
                        <div class="_files" v-for="(file,index) in files" :key="index">
                            <div class="d-flex justify-content-between w-100">
                                <div>
                                    <img class="icon-img" v-if="file.name.endsWith('.pdf')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pdf-icon.svg" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.png')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/png-icon.svg" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.jpg')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.svg')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/svg-icon.svg" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.xls')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/xls-icon.svg" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.doc')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/doc-icon.svg" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.docx')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/docx-icon.svg" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.htm')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/htm-icon.svg" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.html')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/html-icon.svg" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.ppt')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/ppt-icon.svg" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.pptx')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pptx-icon.svg" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.txt')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/txt-icon.svg" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.xlsx')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/xlsx-icon.svg" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.bmp')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/bmp-icon.svg" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.gif')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/gif-icon.svg" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.jpeg')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg-icon.svg" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.tiff')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.avi')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/avi-icon.svg" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.flv')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/flv-icon.svg" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.mpg')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mpg-icon.svg" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.mpeg')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mpeg-icon.svg" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.mp3')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp3-icon.svg" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.mp4')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp4-icon.svg" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.wav')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/wav-icon.svg" />
                                    <img class="icon-img" v-else-if="file.name.endsWith('.wmv')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/wmv-icon.svg" />
                                    <span class="ml-2 fw-600 text-dark fs-14">
                                        {{ file.name }} <span class="ml-3"
                                            style="color:#808495">({{ file.size | prettyBytes }})</span>
                                    </span>
                                </div>
                                <div>
                                    <a :href="file.url" download style="text-decoration: none;">
                                        <i class="icon icon-download"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="images.length && showAttachments" class="files-attachments mt-5">
                        <div class="title_files">
                            <div class="d-flex justify-content-between w-50">
                                <span class="file-text">IMAGES</span>
                            </div>
                        </div>
                        <div class="report-images">
                            <div class="_images" v-for="(image,index) in images" :key="index">
                                <img v-if="image.name.endsWith('.svg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg" />
                                <img v-else :src="image.url"  alt=""/>
                                <!-- <img :src="image.url" alt=""> -->
                                <span>{{ image.name }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="audiovideo.length && showAttachments" class="files-attachments mt-5">
                        <div class="title_files">
                            <div class="d-flex justify-content-between w-50">
                                <span class="file-text">AUDIOS / VIDEOS</span>
                            </div>
                        </div>
                        <div class="report-images">
                            <div class="_images" v-for="(audiovid,index) in audiovideo" :key="index">
                                <video controls>
                                    <source :src="audiovid.url" type="video/*">
                                </video>
                                <span>{{ audiovid.name }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="createJson.sales_target">
                    <div v-if="createJson.sales_target">
                        <div v-if="createJson.sales_target.length">
                            <div class="sales-target-info mt-10" v-for="(sales,index) in createJson.sales_target"
                                :key="index">
                                <div class="infoHeaderHideShow mt-3 mb-3">
                                    <div class="descriptionheader">
                                        <div class="description-text-header-left">
                                            <h5 class="font-weight-bold whiteSpace">Sales Target - {{index+1}}</h5>
                                        </div>
                                        <div class="description-text-header-right">
                                            <span class="collapse-addon">
                                                <i v-if="!sent" @click="edit('salestargettab')"
                                                    class="icon-pencil text-white fs-18"></i>
                                                <i v-if="showSales.includes(index)" @click="expandSalesTarget(index)"
                                                    class="icon-chevron-double-up text-white"></i>
                                                <i v-else @click="expandSalesTarget(index)" class="icon-chevron-double-down text-white"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="showSales.includes(index)">
                                    <div class="row">
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div>
                                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                                    Fiscal Year
                                                    <!-- <sup class="fs-14 ml-02 mandatory">*</sup> -->
                                                </span>
                                            </div>
                                            <div class="review-borders">
                                                <span>{{sales.forecast.target_year}}</span>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div>
                                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                                    Department Name
                                                    <!-- <sup class="fs-14 ml-02 mandatory">*</sup> -->
                                                </span>
                                            </div>
                                            <div class="review-borders">
                                                <span>{{sales.forecast.department}}</span>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div>
                                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                                    Customer Name
                                                    <!-- <sup class="fs-14 ml-02 mandatory">*</sup> -->
                                                </span>
                                            </div>
                                            <div class="review-borders">
                                                <span>{{sales.forecast.customer_name || "-"}}</span>
                                                <!-- <span>{{sales.customer}}</span> -->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-5">
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div>
                                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                                    Branch Name
                                                    <!-- <sup class="fs-14 ml-02 mandatory">*</sup> -->
                                                </span>
                                            </div>
                                            <div class="review-borders">
                                                <!-- <span v-if="sales.branch.name">{{sales.branch.name}}</span> -->
                                                <span>{{sales.forecast.branch_name}}</span>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div>
                                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                                    Product Name
                                                    <!-- <sup class="fs-14 ml-02 mandatory">*</sup> -->
                                                </span>
                                            </div>
                                            <div class="review-borders">
                                                <span>{{sales.forecast.product}}</span>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div>
                                                <span class="ml-2 fs-14 fw-600 text-secondary">
                                                    Sales Person
                                                    <!-- <sup class="fs-14 ml-02 mandatory">*</sup> -->
                                                </span>
                                            </div>
                                            <div class="review-borders">
                                                <span>{{sales.forecast.sales_person_name || "-"}}</span>
                                                <!-- <span v-else>-</span> -->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-5" >
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        <div>
                                            <span class="ml-2 fs-14 fw-600 text-secondary">
                                                Unit of Measure
                                            </span>
                                        </div>
                                        <div class="review-borders">
                                            <span>{{sales.forecast.uom}}</span>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="table-responsive mt-10 w-100" style="overflow-x:auto;"
                                        >
                                        <table class="table-sales w-100">
                                            <thead>
                                                <tr style="background-color: #0b61fc;">
                                                    <th>Month</th>
                                                    <th>Jan</th>
                                                    <th>Feb</th>
                                                    <th>Mar</th>
                                                    <th>Apr</th>
                                                    <th>May</th>
                                                    <th>June</th>
                                                    <th>July</th>
                                                    <th>Aug</th>
                                                    <th>Sep</th>
                                                    <th>Oct</th>
                                                    <th>Nov</th>
                                                    <th>Dec</th>
                                                    <th class="text-wrap">Total Sales Target</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="units" >
                                                    <td>Units</td>
                                                    <td>{{sales.forecast.target.jan}}</td>
                                                    <td>{{sales.forecast.target.feb}}</td>
                                                    <td>{{sales.forecast.target.mar}}</td>
                                                    <td>{{sales.forecast.target.apr}}</td>
                                                    <td>{{sales.forecast.target.may}}</td>
                                                    <td>{{sales.forecast.target.jun}}</td>
                                                    <td>{{sales.forecast.target.jul}}</td>
                                                    <td>{{sales.forecast.target.aug}}</td>
                                                    <td>{{sales.forecast.target.sept}}</td>
                                                    <td>{{sales.forecast.target.oct}}</td>
                                                    <td>{{sales.forecast.target.nov}}</td>
                                                    <td>{{sales.forecast.target.dec}}</td>
                                                    <td style="background-color:#dfe8f4">
                                                        {{sales.forecast.target.jan + sales.forecast.target.feb + sales.forecast.target.mar + sales.forecast.target.apr + sales.forecast.target.may + sales.forecast.target.jun + sales.forecast.target.jul + sales.forecast.target.aug + sales.forecast.target.sept + sales.forecast.target.oct + sales.forecast.target.nov + sales.forecast.target.dec }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="createJson.follow_ups">
                    <div v-if="createJson.follow_ups.length">
                        <div class="follow-up-info mt-10" v-for="(follow,index) in createJson.follow_ups" :key="index">
                            <div class="infoHeaderHideShow mt-3 mb-3">
                                <div class="descriptionheader">
                                    <div class="description-text-header-left">
                                        <h5 class="font-weight-bold whiteSpace">Follow Up - {{index+1}}</h5>
                                    </div>
                                    <div class="description-text-header-right">
                                        <span class="collapse-addon">
                                            <i v-if="!sent" @click="edit('followuptab')"
                                                class="icon-pencil text-white fs-18"></i>
                                            <i v-if="follow.is_expanded" @click="expandFollowUps(follow)"
                                                class="icon-chevron-double-up text-white"></i>
                                            <i v-else @click="expandFollowUps(follow)"
                                                class="icon-chevron-double-down text-white"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="follow.is_expanded">
                                <div class="row" >
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div>
                                            <span class="ml-2 fs-14 fw-600 text-secondary">
                                                Product Name
                                            </span>
                                        </div>
                                        <div v-if="follow.products" class="review-borders product-div">
                                            <div class="secondary-email-list">
                                                <span class="secondary-email" v-for="(product,product_index) in follow.products" :key="product_index">{{product ? product.name : '-' }}</span>
                                            </div>

                                        </div>
                                        <div v-else class="review-borders">
                                            <span class="secondary-email">{{"-"}}</span>

                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        <div>
                                            <span class="ml-2 fs-14 fw-600 text-secondary">
                                                Assigned to
                                            </span>
                                        </div>
                                        <div class="review-borders">
                                            <span v-if="follow.assigned_to">{{follow.assigned_to.full_name || "-"}}</span>
                                            <span v-else>-</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        <div class="d-flex">
                                            <div style="width:70%">
                                                <div>
                                                    <span class="ml-2 fs-14 fw-600 text-secondary">
                                                        Due Date
                                                    </span>
                                                </div>
                                                <div class="mr-3" >
                                                    <div class="review-borders d-flex">
                                                        <span>{{moment(follow.due_date).format("MM/DD/YYYY") || '-'}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style="width:30%">
                                                <div>
                                                    <span class="ml-2 fs-14 fw-600 text-secondary">
                                                        Time
                                                    </span>
                                                </div>
                                                <div class="review-borders">
                                                    <span v-if="follow.time == ''">{{"-"}}</span>
                                                    <span v-else>{{ follow.time }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        <span class="ml-2 fs-14 fw-600 text-secondary">
                                            Price
                                        </span>
                                        <div class="d-flex">
                                            <div class="review-borders mr-3 text-center" style="width:20%">
                                                <span class="fw-600 ">{{loggedInUser.currency.symbol}}</span>
                                            </div>
                                            <div class="review-borders" style="width:80%">
                                                <!--<span v-if="follow.price == 'N/A'">{{follow.price}}</span>-->
                                                <span v-if="follow.price">{{follow.price}}</span>
                                                <span v-else>{{"N/A"}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-5" v-if="showFollowUps.includes(index)">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div>
                                            <span class="ml-2 fs-14 fw-600 text-secondary">
                                                Notes
                                            </span>
                                        </div>
                                        <div class="review-borders" style="height:150px; overflow: auto; white-space: pre-wrap;word-wrap: break-word;">
                                            <div class="text-dark fs-14 fw-600">
                                                {{follow.notes}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!sent" class="m-7" style="display: flex;justify-content: center;">
                    <button type="button" class="btn new-cancel-button mr-3"
                        style="box-shadow: none !important;" @click="goBack">CANCEL</button>
                    <button v-if="userPermissions.call_reports.permitted_actions.send" type="button" class="btn new-save-button mr-3"
                        style="box-shadow: none !important;" :disabled="is_submit" @click="saveDataconfirm">SUBMIT</button>
                </div>
            </div>
        </div>
        <save-call-report modal_name="savecallreport" :call_report_number="call_report_number"></save-call-report>
        <loader-modal modal_name="loader_modal" :message="loadingMessage"></loader-modal>
        <call-report-forward-modal modal_name="call_report_forward_modal" :id="call_report_id"></call-report-forward-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
    import SaveCallReport from "./alertModals/SaveCallReport";
    import LoaderModal from "./alertModals/LoaderModal";
    import callreport from "./mixins/callreport";
    import moment from "moment";
    import CallReportForwardModal from "./CallReportForwardModal";
    import { EventBus } from './eventBus/nav-bar-event';
    import { quillEditor } from 'vue-quill-editor';
    import { SweetModal } from 'sweet-modal-vue';
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    // import theme style
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    export default {
        data() {
            return {
                is_submit:false,
                subsidiary_data: [],
                is_enable: '',
                combinedTo :'',
                combinedFrom:'',
                createJson: {},
                meeting_location_vmodel: "",
                internalCompanyObject: {},
                attachments: [],
                files: [],
                images: [],
                audiovideo: [],
                call_report_number: "",
                call_report_id: "",
                sent: true,
                loadingMessage: "",
                showBasicInfo: true,
                showCompanyDetails: true,
                showCustomerDetails: [],
                showReceiverDetails:[],
                showVendorDetails:[],
                showContactDetails: [],
                showEmailRecipients: true,
                showPermissions:true,
                showMeetingInformation: true,
                showMeetingNotes: true,
                showAttachments: true,
                showSales: [],
                showFollowUps: [],
                editMode: false,
                callReportId: "",
                is_create_edit: '',
                warning_msg:"",
                skip:0,
                limit:10,
                is_followUp:false,
                datefrom: '',
                dateto:'',
                timeform:'',
                timeto:'',
                meeting_start_date: '',
                meeting_start_time: '',
                meeting_end_date: '',
                meeting_end_time: '',
                ajaxCallInProgress: false,
            }
        },
        components: {
            SaveCallReport,
            LoaderModal,
            quillEditor,
            CallReportForwardModal,
            SweetModal,
            HalfCircleSpinner
        },
        mixins: [
            callreport
        ],
        created() {
            // this.createJson = JSON.parse(localStorage.getItem("callReportReviewData"));
            // this.meeting_start_date = this.createJson.meeting_start_date
            // this.meeting_start_time = this.createJson.meeting_start_time
            // this.meeting_end_date = this.createJson.meeting_end_date
            // this.meeting_end_time = this.createJson.meeting_end_time
            // this.loadUTCTime();
            // if(this.createJson.send_copy_to_me == ''){
            //     this.createJson.send_copy_to_me = false
            // }
            // this.is_create_edit = localStorage.getItem("call_report_edit_create");
            // this.meeting_location_vmodel = this.createJson.meeting_location.street + ((this.createJson.meeting_location.street).length > 0 ?  ", " : '') + this.createJson
            //     .meeting_location.city + ((this.createJson.meeting_location.city).length > 0 ?  ", " : '') + this.createJson.meeting_location.state + ((this.createJson.meeting_location.state).length > 0 ?  ", " : '') + this.createJson
            //     .meeting_location.zip_code + ((this.createJson.meeting_location.zip_code).length > 0 ?  ", " : '') + this.createJson.meeting_location.country;
            // if (this.createJson.external_attendees) {
            //     if (this.createJson.external_attendees.length) {
            //         this.createJson.external_attendees.forEach((x, index) => {
            //             if (typeof (x.company_name) === "object" ? x.company_name._id == "" : x.company_name ==
            //                 "") {
            //                 this.createJson.external_attendees = this.createJson.external_attendees.filter(i => i !=
            //                     x);
            //             }
            //             this.showCustomerDetails.push(index);
            //         });
            //     }
            // }
            // if (this.createJson.follow_ups) {
            //     if (this.createJson.follow_ups.length) {
            //         this.createJson.follow_ups.forEach((x, index) => {
            //             x['is_expanded'] = true
            //             if (x.products == "") {
            //                 this.createJson.follow_ups = this.createJson.follow_ups.filter(i => i != x);
            //             }
            //             this.showFollowUps.push(index);
            //         });
            //     }
            // }
            // if(this.createJson.hasOwnProperty("sales_target")){
            //     if (typeof(this.createJson.sales_target) == "array") {
            //         if(this.createJson.sales_target.hasOwnProperty("forecast")){
            //             if (this.createJson.sales_target.forecast.length) {
            //                 this.createJson.sales_target.forecast.forEach((x, index) => {
            //                     this.showSales.push(index);
            //                     this.$forceUpdate()
            //                 });
            //             }
            //         }
            //     } else {
            //         if (this.createJson.sales_target.forecast.length) {
            //             this.createJson.sales_target.forecast.forEach((x, index) => {
            //                 this.showSales.push(index);
            //                 this.$forceUpdate()
            //             });
            //         }
            //     }
            // }

            // this.internalCompanyObject = JSON.parse(localStorage.getItem("internalCompanyObject"));
            // this.attachments = JSON.parse(localStorage.getItem("attachments"));
            // this.attachments.forEach(x => {
            //     let type = x.name.split(".");
            //     if (type[1] == "jpg" || type[1] == "jpeg" || type[1] == "png" || type[1] == "svg") {
            //         this.images.push(x);
            //     } else if (type[1] == "mpg" || type[1] == "mpeg" || type[1] == "mp4" || type[1] == "mp3" ||
            //         type[1] == "wav" || type[1] == "avi" || type[1] == "webm") {
            //         this.audiovideo.push(x);
            //     } else {
            //         this.files.push(x);
            //     }
            // });
            // if (localStorage.hasOwnProperty("callReportID")) {
            //     this.callReportId = localStorage.getItem("callReportID");
            // }
            // if (this.createJson.contact_info) {
            //     if (this.createJson.contact_info.length) {
            //         this.createJson.contact_info.forEach((x, index) => {
            //             this.showContactDetails.push(index);
            //         });
            //     }
            // }
            // if (this.createJson.lead_info) {
            //     if (this.createJson.lead_info.length) {
            //         this.createJson.lead_info.forEach((x, index) => {
            //             this.showReceiverDetails.push(index);
            //         });
            //     }
            // }
            // if (this.createJson.vendor_info) {
            //     if (this.createJson.vendor_info.length) {
            //         this.createJson.vendor_info.forEach((x, index) => {
            //             this.showVendorDetails.push(index);
            //         });
            //     }
            // }

        },
        destroyed() {
            if (!this.editMode) {
                localStorage.clear();
            }
        },
        methods: {
            //convert the date using momnet js
            /**@params = date */
            moment(date) {
                return moment(date);
            },
            async getCallReportDetails() {
                try {
                    this.ajaxCallInProgress = true;
                    let res = await this.getCallReportById(this.$route.params.id);
                    this.createJson = res.response;
                    // if(this.editPreview == false){
                    //     setTimeout(() => {
                    //         let value = this.createJson.start_date.split("/")
                    //         let value1 = this.createJson.end_date.split("/")
                    //         var date1 = value[1] + '/' + value[0] + '/' + value[2];
                    //         var date2 = value1[1] + '/' + value1[0] + '/' + value1[2];
                    //         this.meeting_start_date = date1
                    //         this.meeting_start_time = this.createJson.start_time
                    //         this.meeting_end_date = date2
                    //         this.meeting_end_time = this.createJson.end_time
                    //         let value_n = this.createJson.start_date
                    //         let value_n_split = value_n.split("/")
                    //         var date1 = value_n_split[2] + '-' + value_n_split[1] + '-' + value_n_split[0];
                    //         let d_obj = new Date(date1 + ' ' + '00:00:00');
                    //         this.not_before_start_date = d_obj;
                    //     }, 500);
                    //     this.loadUTCTime();
                    // }
                    this.meeting_location_vmodel = this.createJson.meeting_location.street + ((this.createJson
                            .meeting_location.street).length > 0 ? "," : '') + this.createJson
                        .meeting_location.city + ((this.createJson.meeting_location.city).length > 0 ? "," : '') +
                        this.createJson.meeting_location.state + ((this.createJson.meeting_location.state).length >
                            0 ? "," : '') + this
                        .createJson.meeting_location.zip_code + ((this.createJson.meeting_location.zip_code)
                            .length > 0 ? "," : '') + this.createJson.meeting_location.country;
                    if (this.createJson.meeting_attachments.length) {
                        this.attachments = this.createJson.meeting_attachments;
                        this.attachments.forEach(x => {
                            let type = x.name.split(".");
                            if (type[1] == "jpg" || type[1] == "jpeg" || type[1] == "png" || type[1] == "svg") {
                                this.images.push(x);
                            } else if (type[1] == "mpg" || type[1] == "mpeg" || type[1] == "mp4" || type[1] == "mp3" ||
                                type[1] == "wav" || type[1] == "avi" || type[1] == "webm") {
                                this.audiovideo.push(x);
                            } else {
                                this.files.push(x);
                            }
                        });
                    }
                    if (this.createJson.external_attendees) {
                        if (this.createJson.external_attendees.length) {
                            this.createJson.external_attendees.forEach((x, index) => {
                                if (typeof (x.company_name) === "object" ? x.company_name._id == "" : x.company_name ==
                                    "") {
                                    this.createJson.external_attendees = this.createJson.external_attendees.filter(i => i !=
                                        x);
                                }
                                this.showCustomerDetails.push(index);
                            });
                        }
                    }
                    if (this.createJson.follow_ups) {
                        if (this.createJson.follow_ups.length) {
                            this.createJson.follow_ups.forEach((x, index) => {
                                x['is_expanded'] = true
                                if (x.products == "") {
                                    this.createJson.follow_ups = this.createJson.follow_ups.filter(i => i != x);
                                }
                                this.showFollowUps.push(index);
                            });
                        }
                    }
                    if(this.createJson.hasOwnProperty("sales_target")){
                        if (typeof(this.createJson.sales_target) == "array") {
                            if(this.createJson.sales_target.hasOwnProperty("forecast")){
                                if (this.createJson.sales_target.forecast.length) {
                                    this.createJson.sales_target.forecast.forEach((x, index) => {
                                        this.showSales.push(index);
                                        this.$forceUpdate()
                                    });
                                }
                            }
                        } else {
                            if (this.createJson.sales_target.forecast.length) {
                                this.createJson.sales_target.forecast.forEach((x, index) => {
                                    this.showSales.push(index);
                                    this.$forceUpdate()
                                });
                            }
                        }
                    }
                    if (this.createJson.contact_info) {
                        if (this.createJson.contact_info.length) {
                            this.createJson.contact_info.forEach((x, index) => {
                                this.showContactDetails.push(index);
                            });
                        }
                    }
                    if (this.createJson.lead_info) {
                        if (this.createJson.lead_info.length) {
                            this.createJson.lead_info.forEach((x, index) => {
                                this.showReceiverDetails.push(index);
                            });
                        }
                    }
                    if (this.createJson.vendor_info) {
                        if (this.createJson.vendor_info.length) {
                            this.createJson.vendor_info.forEach((x, index) => {
                                this.showVendorDetails.push(index);
                            });
                        }
                    }

                    this.ajaxCallInProgress = false;
                } catch (reason) {
                    this.ajaxCallInProgress = false;
                }
            },
            //API call to set the local time into the start and end date and time
            async loadUTCTime() {
                let value = this.meeting_end_date.split("/")
                let value1 = this.meeting_start_date.split("/")
                var date1 = value[1] + '/' + value[0] + '/' + value[2];
                var date2 = value1[1] + '/' + value1[0] + '/' + value1[2];
                try {
                    /**@params = end_date, @params = end_time, @params = start_date, @params = start_time */
                    let params = {
                        end_date: date1,
                        end_time: this.meeting_end_time,
                        start_date: date2,
                        start_time: this.meeting_start_time,
                        timezone:this.loggedInUser.time_zone
                    }
                    let response = await this.getUTCTime(params)
                    let data = response.response;
                    this.combinedTo = data.meeting_time_to
                    this.combinedFrom = data.meeting_time_from
                } catch (error) {
                }
            },
            //redirecting to the callr eport list view
            goBack() {
                //this.edit("callreporttab");
                this.$router.push("/callreportlist");
            },
            //show the forward call report modal
            forwardCallReport() {
                this.$modal.show("call_report_forward_modal");
            },
            //hide/show the basic information section
            expandBasicInfo() {
                if (!this.showBasicInfo) {
                    this.showBasicInfo = true;
                } else {
                    this.showBasicInfo = false;
                }
            },
            //hide/show the company details section
            expandCompanyDetails() {
                if (!this.showCompanyDetails) {
                    this.showCompanyDetails = true;
                } else {
                    this.showCompanyDetails = false;
                }
            },
            //hide/show the customer details section
            /**@params = index*/
            expandCustomerDetails(index) {
                if (!this.showCustomerDetails.includes(index)) {
                    this.showCustomerDetails.push(index);
                } else {
                    let find_index = this.showCustomerDetails.findIndex(el => el === index);
                    this.showCustomerDetails.splice(find_index, 1);
                }
            },
            //hide/show the contact details section
            /**@params = index*/
            expandContactDetails(index){
                if (!this.showContactDetails.includes(index)) {
                    this.showContactDetails.push(index)
                } else {
                    let find_index = this.showContactDetails.findIndex(el => el === index);
                    this.showContactDetails.splice(find_index, 1);
                }
            },
            //hide/show the lead details section
            /**@params = index*/
            expandLeadDetails(index){
                if (!this.showReceiverDetails.includes(index)) {
                    this.showReceiverDetails.push(index)
                } else {
                    let find_index = this.showReceiverDetails.findIndex(el => el === index);
                    this.showReceiverDetails.splice(find_index, 1);
                }
            },
            expandVendorDetails(index){
                if (!this.showVendorDetails.includes(index)) {
                    this.showVendorDetails.push(index)
                } else {
                    let find_index = this.showVendorDetails.findIndex(el => el === index);
                    this.showVendorDetails.splice(find_index, 1);
                }
            },
            //hide/show the email recipients section
            expandEmailRecipients() {
                if (!this.showEmailRecipients) {
                    this.showEmailRecipients = true;
                } else {
                    this.showEmailRecipients = false;
                }
            },
            //hide/show the permission section
            expandPermission() {
                if (!this.showPermissions) {
                    this.showPermissions = true;
                } else {
                    this.showPermissions = false;
                }
            },
            //hide/show the meeting information section
            expandMeetingInformation() {
                if (!this.showMeetingInformation) {
                    this.showMeetingInformation = true;
                } else {
                    this.showMeetingInformation = false;
                }
            },
            //hide/show the meeting notes
            expandMeetingNotes() {
                if (!this.showMeetingNotes) {
                    this.showMeetingNotes = true;
                } else {
                    this.showMeetingNotes = false;
                }
            },
            //hide/show the attachments
            expandAttachments() {
                if (!this.showAttachments) {
                    this.showAttachments = true;
                } else {
                    this.showAttachments = false;
                }
            },
            //hide/show the sales target
            /**@params = index*/
            expandSalesTarget(index) {
                if (!this.showSales.includes(index)) {
                    this.showSales.push(index);
                    this.$forceUpdate()
                } else {
                    this.showSales.splice(index, 1);
                    this.$forceUpdate()
                }
            },
            //hide/show the follow up section
            /**@params = index*/
            expandFollowUps(follow) {
                follow.is_expanded = !follow.is_expanded
                this.$forceUpdate()
            },
            //edit preview mode
            /**@params = part*/
            edit(part) {
                this.editMode = true;
                localStorage.setItem("partToShow", part);
                if (this.$route.path == `/editcallreportreview/${this.$route.params.id}`) {
                    this.$router.push("/editcallreport/" + this.$route.params.id);
                } else if(this.$route.path == `/copycallreportreview/${this.$route.params.id}`) {
                    this.$router.push("/copycallreport/" + this.$route.params.id);
                } else {
                    this.$router.push("/callreport");
                }
                setTimeout(() => {
                    EventBus.$emit('edit_from_preview');
                }, 1000);
            },
            //redirect to the copy call report
            copyCallReport() {
                localStorage.setItem("callreportid", this.call_report_id);
                this.$router.push("/copycallreport/"+this.call_report_id);
            },
            //save/update the data of the call report
            async saveDataconfirm() {
                try {
                   // this.loadUTCTime();
                    this.is_submit = true;
                    let attachmentstosend = [];
                    //checking the attachments data
                    if (this.attachments.length) {
                        this.attachments.forEach(x => {
                            attachmentstosend.push({
                                name: x.name,
                                size: Number(x.size),
                                url: x.url,
                            });
                        });
                    }
                    if (this.createJson.status == "sent") {
                        this.loadingMessage = "Sending Call Report Please Wait...";
                        this.$modal.show("loader_modal");
                        let external_attendees_data = [];
                        let vendor_data = [];
                        if(this.createJson.vendor_info.length != 0){
                            if(this.createJson.vendor_info[0].vendor_primary_attendee != ""){
                                this.createJson.vendor_info.forEach(x => {
                                    vendor_data.push({
                                        id: x.vendor_name._id,
                                        name: x.vendor_name.company_name,
                                        vendor_primary_attendee: x.vendor_primary_attendee
                                    })
                                })
                            }
                        }
                        if (this.createJson.external_attendees && this.createJson.external_attendees.length) {
                            this.createJson.external_attendees.forEach(x => {
                                // x.secondary_employees.forEach((element, index) => {
                                //     x.secondary_employees[index] = element.primary_email
                                // });
                                if (Array.isArray(x.secondary_employees)) {
                                    x.secondary_employees.forEach((element, index) => {
                                        x.secondary_employees[index] = element && element.primary_email ? element.primary_email : (typeof element == 'string' ? element : '')
                                    });
                                    x.secondary_employees = x.secondary_employees.filter(el => el)
                                } else {
                                    x.secondary_employees = []
                                }
                                //pushing the external attendees data
                                external_attendees_data.push({
                                    branch: x.branch,
                                    name: x.company_name.customer_name,
                                    department: x.department,
                                    primary_employee: x.primary_employee.primary_email,
                                    secondary_employees: x.secondary_employees || [],
                                    status: x.status,
                                    id:x.company_name.id
                                });
                            });
                        };
                        //adding the internal company data
                        let internal_company_data = {};
                        if (Object.keys(this.createJson.internal_company).length > 0) {
                            if(this.is_create_edit == 'create') {
                                Object.assign(internal_company_data, {
                                    company_attendees: [],
                                    other_attendees: [],
                                    //subsidiary_attendees:[],
                                    // branch: {
                                    //     _id: this.createJson.internal_company.branch.id,
                                    //     name: this.createJson.internal_company.branch.name,
                                    // },
                                    //department: this.createJson.internal_company.department,
                                    // primary_attendee: {
                                    //     email_id: this.createJson.internal_company.primary_attendee.email ? this.createJson.internal_company.primary_attendee.email : this.createJson.internal_company.primary_attendee.email_id,
                                    //     full_name: this.createJson.internal_company.primary_attendee.full_name,
                                    // },
                                });
                            } else if(this.is_create_edit == 'edit') {
                                Object.assign(internal_company_data, {
                                    company_attendees: [],
                                    other_attendees: []
                                });
                            }
                            this.createJson.internal_company.company_attendees.forEach(x => {
                                internal_company_data.company_attendees.push({
                                    email_id: x.email_id ? x.email_id : x.email,
                                    full_name: x.full_name,
                                });
                            });
                            if(this.createJson.internal_company.other_attendees) {
                                if(this.createJson.internal_company.other_attendees.length) {
                                    this.createJson.internal_company.other_attendees.forEach(x => {
                                        internal_company_data.other_attendees.push({
                                            email_id: x.email_id ? x.email_id : x.email,
                                            full_name: x.full_name,
                                        });
                                    });
                                }
                            }
                        };
                        //passing the followup data to save
                        let follow_ups_data = [];
                        if (this.createJson.follow_ups && this.createJson.follow_ups.length) {
                            this.createJson.follow_ups.forEach((x,index) => {
                                let products = []
                                x.products.forEach((product, pro_index) => {
                                    products.push({
                                        id: product.id,
                                        name: product.name,
                                    })
                                })
                                if(x.assigned_to) {
                                    follow_ups_data.push({
                                        assigned_to: {
                                            id: x.assigned_to.user_id ? x.assigned_to.user_id : x.assigned_to.id,
                                            full_name: x.assigned_to.full_name || "",
                                        },
                                        due_date: moment(x.due_date).format("YYYY/MM/DD"),
                                        time: x.time,
                                        price: x.price || "",
                                        notes: x.notes || "",
                                        products: products,
                                    });
                                    this.showFollowUps.push(index);
                                }
                            });
                        };
                        //passing the sales target data to save
                        let sales_target_data = {
                            forecast: [],
                            document_type: "forecast",
                        };

                        if(this.createJson.sales_target) {
                            if (this.createJson.sales_target.forecast && this.createJson.sales_target.forecast.length) {
                                this.createJson.sales_target.forecast.forEach((x,index) => {
                                    sales_target_data.forecast.push({
                                        target_year: x.target_year || "",
                                        customer: x.customer_id ? x.customer_id.customer_name : "",
                                        branch: x.branch || "",
                                        department: x.department,
                                        product: x.product ? x.product.name : " ",
                                        product_code: x.product ? x.product.product_code : "",
                                        product_id: x.product ? x.product.id || x.product._id : "",
                                        category: x.product ? x.product.category : "",
                                        sub_category: x.product ? x.product.sub_category : "",
                                        sales_person: x.sales_person ? x.sales_person.full_name : '',
                                        uom: x.uom,
                                        target: {
                                            jan: x.target.jan,
                                            feb: x.target.feb,
                                            mar: x.target.mar,
                                            apr: x.target.apr,
                                            may: x.target.may,
                                            jun: x.target.jun,
                                            jul: x.target.jul,
                                            aug: x.target.aug,
                                            sept: x.target.sept,
                                            oct: x.target.oct,
                                            nov: x.target.nov,
                                            dec: x.target.dec,
                                        },
                                    });
                                    this.showSales.push(index);
                                    this.$forceUpdate()
                                });
                            };
                        }
                        //passing the lead info data to save
                        let lead_info_data =[]
                        if (this.createJson.lead_info && this.createJson.lead_info.length ) {
                            this.createJson.lead_info.forEach((x, index) => {
                                lead_info_data.push({
                                    id: x.id,
                                    name: x.name.full_name || '',
                                    company_name: x.company_name,
                                    status:x.status
                                });
                            });
                        }
                        //passing the contact info data to save
                        let contact_info_data =[]
                        if (this.createJson.contact_info && this.createJson.contact_info.length ) {
                            this.createJson.contact_info.forEach((x, index) => {
                                contact_info_data.push({
                                    id: x.id,
                                    name: x.name.full_name || '',
                                    company_name: x.company_name
                                });
                            });
                        }
                        //assigning recipient email individual data into the recipientEmailIndividual, avoiding to modify the structure of original data
                        let recipientEmailIndividual =[]
                        if (this.createJson.recipient_email.individual && this.createJson.recipient_email.individual.length) {
                            recipientEmailIndividual = JSON.parse(JSON.stringify(this.createJson.recipient_email.individual));
                            recipientEmailIndividual.forEach((x, index) => {
                                recipientEmailIndividual[index] = x.email
                            })
                        }
                        //assigning recipient email team data into the recipientEmailTeam, avoiding to modify the structure of original data
                        let recipientEmailTeam = []
                        if (this.createJson.recipient_email.team && this.createJson.recipient_email.team.length) {
                            recipientEmailTeam = JSON.parse(JSON.stringify(this.createJson.recipient_email.team));
                            recipientEmailTeam.forEach((x, index) => {
                                recipientEmailTeam[index] = x.email_id
                            })
                        }
                        //assigning permission individual data into the permissionsEmailIndividual, avoiding to modify the structure of original data
                        let permissionsEmailIndividual =[]
                        let permission_ind_data =[]
                        if (this.createJson.permissions.individual) {
                            permissionsEmailIndividual = JSON.parse(JSON.stringify(this.createJson.permissions.individual))
                            if (permissionsEmailIndividual && permissionsEmailIndividual.length) {
                                permissionsEmailIndividual.forEach((x, index) => {
                                    permission_ind_data.push({
                                        email_id : x.email,
                                        id :x.user_id || x.id,
                                        name: x.full_name || x.name
                                    })
                                })

                            }
                        }
                        //assigning permission team data into the recipientEmailIndividual, avoiding to modify the structure of original data
                        let permissionsEmailTeam = []
                        let permission_team_data =[]
                        if (this.createJson.permissions.team) {
                            permissionsEmailTeam = JSON.parse(JSON.stringify(this.createJson.permissions.team))
                            if (permissionsEmailTeam && permissionsEmailTeam.length) {
                                permissionsEmailTeam.forEach((x, index) => {
                                    permission_team_data.push({
                                        email_id : x.email_id,
                                        id :x.id,
                                        name: x.full_name || x.name
                                    })
                                })
                            }
                        }
                        let params = {
                            _id: this.createJson._id || "",
                            title: this.createJson.title,
                            owner_email: this.createJson.owner_email,
                            owner_name: this.createJson.owner_name ? this.createJson.owner_name.full_name : "",
                            meeting_time_from: this.combinedFrom,
                            meeting_time_to: this.combinedTo,
                            meeting_type: this.createJson.meeting_type,
                            meeting_notes_subject: this.createJson.meeting_notes_subject,
                            call_report_type: this.createJson.call_report_type,
                            meeting_location: this.createJson.meeting_location,
                            internal_company: internal_company_data,
                            external_attendees: external_attendees_data,
                            vendor_info: vendor_data,
                            lead_info:lead_info_data,
                            contact_info:contact_info_data,
                            receiver_type:this.createJson.receiver_type,
                            follow_ups: follow_ups_data,
                            meeting_timezone: this.createJson.meeting_timezone ? this.createJson.meeting_timezone.value : '',
                            meeting_notes: this.createJson.meeting_notes,
                            meeting_attachments: attachmentstosend,
                            sales_target: sales_target_data,
                            general_access:this.createJson.general_access,
                            recipient_email:{
                                individual : recipientEmailIndividual,
                                team : recipientEmailTeam
                            },
                            permissions: {
                                individual : permission_ind_data,
                                team : permission_team_data
                            },
                            status: this.createJson.status,
                            send_copy_to_me: this.createJson.send_copy_to_me,
                            author_name: this.createJson.author_name,
                            author_email: this.createJson.author_email,
                            meeting_notes_table: this.createJson.meeting_notes_table,
                            call_report_category: this.createJson.call_report_category,
                            branch_name : this.createJson.branch_name
                        };
                        if (!(params._id)) {
                            delete params["_id"];
                        }
                        if (!(params.owner_name)) {
                            delete params["owner_name"];
                            delete params["owner_email"];
                        }
                        if (params.external_attendees.length) {
                            params.external_attendees.forEach(x => {
                                if (x.company_name == "") {
                                    params.external_attendees = params.external_attendees.filter(i => i !=
                                        x);
                                }
                            });
                        }
                        //deleting the ids and other data after saving the created/copied/drafted call report
                        if (!params.external_attendees.length) {
                            delete params["external_attendees"];
                        }
                        if (params.follow_ups.length) {
                            delete params["is_expanded"]
                            params.follow_ups.forEach(x => {
                                if (x.product == "") {
                                    params.follow_ups = params.follow_ups.filter(i => i != x);
                                }
                            });
                        }
                        if (params.sales_target.forecast.length) {
                            params.sales_target.forecast.forEach(x => {
                                if (x.customer_id == "") {
                                    params.sales_target.forecast = params.sales_target.forecast.filter(i =>
                                        i != x);
                                }
                            });
                        }
                        if (!params.sales_target.forecast.length) {
                            params.sales_target = {};
                        }
                        //API call to save the call report
                        let res = await this.storeCallReport(params);
                        if (res.status_id == 1 && this.createJson.status == "sent") {
                            this.$modal.hide("loader_modal");
                            localStorage.clear();
                            if (res.call_report_number) {
                                this.call_report_number = res.call_report_number;
                                this.call_report_id = res.id;
                            } else {
                                this.call_report_number = "";
                            }
                            this.$modal.show("savecallreport");
                            this.sent = true;
                        } else {
                            this.$modal.hide("loader_modal");
                            this.$forceUpdate()
                        }
                    }
                } catch (reason) {
                    this.is_submit = false;
                    this.$modal.hide("loader_modal");
                    this.$swal({
                        text: reason,
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonText: "OK",
                        confirmButtonColor: "#005dae",
                    });
                }
            },
        },
        mounted() {
            this.call_report_id = this.$route.params.id;
            if(this.$route.params.id) {
                this.getCallReportDetails(this.$route.params.id)
            }
        },
        computed:{
            userPermissions(){
                return this.$store.getters.userPermissions;
            },
            loggedInUser() {
                return this.$store.state.loggedInUser;
            },
            checkBrowser() {
                return this.$store.state.checkBrowser;
            },
        }
    }
</script>
<style scoped>
    .block-callreport {
        border-radius: 11px;
        box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
        background-color: #ffffff;
        padding: 5px 50px 15px 50px;
        margin-bottom: 22px;
    }

    .report-title {
        color: #504f4f;
        font-size: 24px;
        font-weight: bold;
    }

    .infoHeaderHideShow {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        min-height: 40px;
        position: relative;
        -webkit-box-shadow: none;
        box-shadow: none;
        border-radius: 5px;
        line-height: 40px;
        cursor: pointer;
    }

    .infoHeaderHideShow>.descriptionheader {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 10px 10px;
        background-color: #00448b;
        border-radius: 2px;
        /* border-bottom: 1px solid transparent; */
    }

    .infoHeaderHideShow>.descriptionheader .description-text-header-left h5 {
        font-size: 14px;
        font-weight: bold;
        margin: 0;
        color: #ffffff !important;
    }

    .infoHeaderHideShow>.descriptionheader .description-text-header-right {
        font-size: 24px;
        margin-left: auto;
        padding-left: 12px;
        color: #00448b;
        font-weight: 500;
    }

    .infoHeaderHideShow>.descriptionheader .description-text-header-right {
        /* display: block;
  border-bottom: 1px solid #b2b2b3; */
        width: 100%;
        margin-left: 10px;
    }

    .whiteSpace {
        white-space: nowrap;
    }

    .collapse-addon {
        position: relative;
        display: flex;
        float: right;
        cursor: pointer;
    }

    .review-borders {
        margin: 8.5px 0 0;
        padding: 6px;
        border-radius: 5px;
        border: solid 0.5px #3f3f3f !important;
        background-color: #ffffff;
        min-height: 33px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .secondary-email-list {
        display: flex;
        flex-direction: row;
        flex-flow: wrap;
    }

    .secondary-email {
        padding: 3.5px 19px 3.5px 7.5px;
        border-radius: 5px;
        background-color: rgba(197, 223, 253, 0.28);
        white-space: nowrap;
        margin: 5px;
    }

    .notes-receipts {
        padding-left: 0px;
    }

    .meeting-notes-table tbody tr td {
        border: 0.5px solid rgba(0, 0, 0, 0.35);
        text-align: center;
        min-width: 10em;
    }

    .meeting-notes-table>tbody>tr:first-child td {
        border-top: 0px !important;
        border-bottom: 0px !important;
    }

    .meeting-notes-table>tbody>tr:first-child td:first-child {
        border-top-left-radius: 5px;
    }

    .meeting-notes-table>tbody>tr:first-child td:last-child {
        border-top-right-radius: 5px;
    }

    .meeting-notes-table tbody tr td input {
        font-weight: 600;
        text-align: center;
    }

    .meeting-notes-table>tbody>tr:first-child td,
    .meeting-notes-table>tbody>tr:first-child td input {
        background: #00448b !important;
        color: #ffffff !important;
    }

    .table.table-sales {
        border-radius: 5px;
    }

    .table-sales {
        border: solid 1px #707070;
    }

    .table-sales td,
    .table-sales th {
        border: 1px solid #707070;
    }

    .table-sales thead th {
        color: #fff;
        text-align: center;
    }

    .table-sales tbody td {
        text-align: center;
    }

    .table-sales thead td,
    .table-sales thead th {
        border-bottom-width: 0px;
        white-space: nowrap;
        height: 4em;
    }

    .table.table-sales thead th {
        border-bottom: 0px solid #707070 !important;
        font-weight: bold;
        font-size: 14px !important;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #fff !important;
        text-transform: none !important;
        vertical-align: middle;
        text-align: center;
    }

    .table.table-sales tbody td {
        padding: 0 !important;
        color: #303031;
        font-size: 13px;
    }

    .table.table-sales thead tr th:first-child {
        border-top-left-radius: 5px;
    }

    .table.table-sales thead tr th:last-child {
        border-top-right-radius: 5px;
    }

    .units td {
        font-weight: bold !important;
        height: 38px;
    }

    .connect-helpdesk {
        background-color: #00448b;
        border-radius: 2px;
        padding: 4px 10px 4px 10px;
        color: #ffffff;
        font-weight: bold;
        font-size: 14px;
    }

    .ticket-detail {
        padding: 2.5px 6.5px 4px 6.5px;
        border-radius: 5px;
        box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.16);
        background-color: #ffffff;
        font-size: 14px;
        width: 300px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .example {
        display: flex;
        flex-direction: column;
    }
    .example .editor {
        height: 40rem;
        overflow: hidden;
    }
    .example .output {
        width: 100%;
        height: 20rem;
        margin: 0;
        border: 1px solid #ccc;
        overflow-y: auto;
        resize: vertical;
    }
    .example .output.code {
        padding: 1rem;
        height: 16rem;
    }
    .example .output.ql-snow {
        border-top: none;
        height: 24rem;
    }
    .height-align {
        max-height: 84px !important;
        overflow-x: scroll !important;
    }
    .icon-img{
        width: 33px;
        height: 40px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ViewCallReportAfterCreate.vue